const isTextEmpty = shape => !shape.getIn(['textBody', 'text']);

export default isTextEmpty;
